import { ReactNode } from 'react';
import { Skeleton } from '@mui/material';

import { TransactionStatus } from '@features/transactions/constants';

import TransactionDetailsCard from '../transaction-details-card/TransactionDetailsCard';

interface TransactionHistoryProps {
  paymentHistoryVal: {
    title: string;
    value: string | ReactNode;
    className?: string;
  }[];
  isLoading: boolean;
  transactionStatus: TransactionStatus;
}

const TransactionHistory = ({
  paymentHistoryVal,
  isLoading,
  transactionStatus
}: TransactionHistoryProps) => {
  const filteredPaymentHistoryVal = paymentHistoryVal.filter(
    (item) => item.value !== ''
  );

  return (
    <div className="flex w-full flex-wrap justify-stretch border-b border-grey10 py-4 last:border-none ">
      {isLoading ? (
        <div className="w-full">
          <Skeleton
            key={Math.random()}
            animation="wave"
            className="size-full"
          />
        </div>
      ) : (
        filteredPaymentHistoryVal.map((paymentInfo) => (
          <TransactionDetailsCard
            key={`${paymentInfo.title || 'detail'}-${
              typeof paymentInfo.value === 'string' ? paymentInfo.value : ''
            }`}
            isLoading={false}
            paymentDetails={paymentInfo}
            transactionStatus={transactionStatus}
          />
        ))
      )}
    </div>
  );
};

export default TransactionHistory;
